module.exports = __webpack_public_path__ + "static/img/baselineRepair_pic02.872c72e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baselineRepair/baselineRepair_pic02.png
// module id = 467
// module chunks = 1